<script>
export default {
    props: ['top', 'left', 'right']
}
</script>
<template>
    <section class="opacity-admin-bg" :style="{ 'left': left, 'top': top, 'right': right }">
        <slot></slot> 
    </section>
</template>

<style scoped>
    section {
        position: absolute;
        padding:10px;
        width: 300px;
        z-index: 10;
        background-color: rgba(115, 94, 80, 0.85);
        color: white;
        border-radius: 3px;
    }
</style>